/* Direct GA4 completion tracking. No Google Tag Manager dependency. */
(() => {
  if (window.EveQuizAnalytics) return;
  const configured = new Set();
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;

  window.EveQuizAnalytics = (settings = {}, sectionId = '') => {
    const measurementId = String(settings.measurementId || '').trim();
    const valid = settings.enabled === true && /^G-[A-Z0-9]+$/.test(measurementId);
    const preview = settings.preview === true || window.Shopify?.designMode === true;
    const storageKey = `eveQuizGA4:${sectionId}:${measurementId}:${settings.testMode ? 'test' : 'live'}`;
    let sent = false;
    // An ordinary quiz URL starts a new attempt. Explicit progress URLs resume it.
    let fresh = ![...new URLSearchParams(location.search).keys()].some(key => key.startsWith('eq_'));
    if (fresh) {
      try { sessionStorage.removeItem(storageKey); } catch (_) {}
    }

    if (valid && !window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
    }

    const complete = payload => {
      try {
        if (!valid || sent || (preview && !settings.testMode) || !allowed()) return false;
        if (!fresh) {
          try { if (sessionStorage.getItem(storageKey) === 'sent') { sent = true; return false; } } catch (_) {}
        }
        // If the Google integration is sandboxed, opt in to loading a storefront tag.
        // This tag sends only the quiz event, not another page_view.
        if (settings.loadTag) {
          window.dataLayer = window.dataLayer || [];
          if (typeof window.gtag !== 'function') {
            window.gtag = function () { window.dataLayer.push(arguments); };
            window.gtag('js', new Date());
          }
          if (!configured.has(measurementId)) {
            window.gtag('config', measurementId, {
              send_page_view: false, allow_google_signals: false,
              allow_ad_personalization_signals: false
            });
            const existing = [...document.scripts].some(script =>
              script.src.includes('/gtag/js') && new URL(script.src).searchParams.get('id') === measurementId);
            if (!existing) {
              const script = document.createElement('script');
              script.async = true;
              script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
              document.head.appendChild(script);
            }
            configured.add(measurementId);
          }
        }
        if (typeof window.gtag !== 'function') return false;
        const a = payload.answers;
        const parameters = {
          send_to: measurementId,
          quiz_version: '1',
          hair_type: a.hairType,
          hair_fallback: a.hairFallback || 'not_needed',
          quiz_age_range: a.age,
          frustration: a.frustration,
          current_routine: a.routine,
          drying_speed: a.drying,
          goals: [...a.goals].sort().join(','),
          result_type: payload.cluster,
          // Keep the eight-product recommendation below GA4's string value limit.
          recommended_products: payload.products.join(','),
          page_location: `${location.origin}${location.pathname}`
        };
        if (settings.testMode) parameters.debug_mode = true;
        window.gtag('event', settings.testMode ? 'quiz_completed_test' : 'quiz_completed', parameters);
        sent = true;
        fresh = false;
        try { sessionStorage.setItem(storageKey, 'sent'); } catch (_) {}
        return true;
      } catch (_) {
        // Analytics must never interrupt result preparation.
        return false;
      }
    };
    return {
      complete,
      restart() {
        sent = false;
        fresh = true;
        try { sessionStorage.removeItem(storageKey); } catch (_) {}
      }
    };
  };
})();
